var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods-info-content" },
    [
      _c(
        "el-form-item",
        {
          staticClass: "goods-item",
          attrs: {
            label: "货物：",
            prop: _vm.cardKey + ".goods." + _vm.itemIndex + ".goodsCategoryid"
          }
        },
        [
          _c(
            "el-select",
            {
              attrs: {
                filterable: "",
                placeholder: _vm.getInputText("goodsCategoryid")
              },
              on: {
                focus: function(e) {
                  return _vm.selectFocus(_vm.cardKey, _vm.itemIndex)
                },
                change: function(val) {
                  return _vm.selectChange(val, _vm.cardKey, _vm.itemIndex)
                }
              },
              model: {
                value:
                  _vm.ruleForm[_vm.cardKey].goods[_vm.itemIndex]
                    .goodsCategoryid,
                callback: function($$v) {
                  _vm.$set(
                    _vm.ruleForm[_vm.cardKey].goods[_vm.itemIndex],
                    "goodsCategoryid",
                    $$v
                  )
                },
                expression: "ruleForm[cardKey].goods[itemIndex].goodsCategoryid"
              }
            },
            _vm._l(_vm.goodsArr, function(item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          staticClass: "form-item-wrap-middle",
          attrs: {
            label: "重量：",
            prop: _vm.cardKey + ".goods." + _vm.itemIndex + ".goodsWeight"
          }
        },
        [
          _c("el-input", {
            attrs: {
              type: "number",
              placeholder: _vm.getInputText("goodsWeight")
            },
            model: {
              value: _vm.ruleForm[_vm.cardKey].goods[_vm.itemIndex].goodsWeight,
              callback: function($$v) {
                _vm.$set(
                  _vm.ruleForm[_vm.cardKey].goods[_vm.itemIndex],
                  "goodsWeight",
                  $$v
                )
              },
              expression: "ruleForm[cardKey].goods[itemIndex].goodsWeight"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        {
          attrs: {
            label: "件数：",
            prop: _vm.cardKey + ".goods." + _vm.itemIndex + ".goodsNumber"
          }
        },
        [
          _c("el-input", {
            attrs: {
              type: "number",
              placeholder: _vm.getInputText("goodsNumber")
            },
            model: {
              value: _vm.ruleForm[_vm.cardKey].goods[_vm.itemIndex].goodsNumber,
              callback: function($$v) {
                _vm.$set(
                  _vm.ruleForm[_vm.cardKey].goods[_vm.itemIndex],
                  "goodsNumber",
                  $$v
                )
              },
              expression: "ruleForm[cardKey].goods[itemIndex].goodsNumber"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-ee3716ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-ee3716ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/personal/deliver/components/handlingWrapper/components/goodsCard/index.vue
// module id = null
// module chunks = 